"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
const react_redux_1 = require("react-redux");
const redux_form_1 = require("redux-form");
const index_1 = __importDefault(require("./index"));
const app_1 = require("ducks/app");
const contact_infos_1 = require("ducks/contact-infos");
const contact_infos_2 = require("ducks/contact-infos");
const households_1 = require("ducks/households");
// ducks
const profile_1 = require("ducks/profile");
const app_2 = require("selectors/app");
const contact_infos_3 = require("selectors/contact-infos");
const profile_2 = require("selectors/profile");
// selectors
const user_1 = require("selectors/user");
const mapStateToProps = (state) => {
    const currentProfile = (0, profile_2.getCurrentProfile)(state);
    const userEmail = (0, user_1.getUserEmail)(state);
    const contactInfos = (0, contact_infos_3.getContactInfos)(state);
    const user = (0, user_1.getUser)(state);
    const contactInfo = (0, contact_infos_3.findByPerson)(contactInfos, currentProfile.id);
    const selector = (0, redux_form_1.formValueSelector)('profile-settings');
    const contactInfoValues = selector(state, 'contactInfos');
    const isUCIenabled = (0, user_1.getIsUCIenabled)(state);
    // set the email address to the user.email if the currentProfile doesn't have
    // a uuid (it's the same as the user.person_uuid)
    const initialContactInfoData = (0, contact_infos_3.loadContactInfoFormData)(contactInfo);
    if (!currentProfile.uuid) {
        initialContactInfoData.emailAddress = userEmail;
    }
    return {
        initialValues: {
            profile: { ...currentProfile, capabilities: user.capabilities, tsOneBanner: user.tsOneBanner },
            contactInfos: initialContactInfoData,
        },
        currentProfile,
        contactInfos,
        contactInfosLoaded: (0, contact_infos_3.contactInfosLoaded)(state),
        selectedCountry: contactInfoValues ? contactInfoValues.addressCountry : null,
        online: (0, app_2.online)(state),
        contactInfoValues,
        isUCIenabled,
    };
};
exports.mapStateToProps = mapStateToProps;
exports.mapDispatchToProps = {
    submitProfileForm: profile_1.submitProfileForm,
    submitContactForm: contact_infos_1.submitContactForm,
    submitProfileSettings: profile_1.submitProfileSettings,
    showSaveNeeded: app_1.showSaveNeeded,
    doSave: app_1.doSave,
    loadContactInfos: contact_infos_2.loadContactInfos,
    loadHouseholds: households_1.loadHouseholds,
    submitContactFormIfMissingId: contact_infos_2.submitContactFormIfMissingId,
};
exports.default = (0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps)(index_1.default);
